import type { PartnerGeneralResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { GeneralInfoForm } from "Partner/Components/Form/GeneralInfoForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";

const generalInfoResources = Resources.base.partner.detail.generalInfo;

type PartnerGeneralFormWidgetProps = {
	partnerId: number;
	data: PartnerGeneralResponseDto;
	serviceAreas: Array<{
		marketRegionId: number;
		originAddress: string;
		isPrimary: boolean;
		isActive: boolean;
	}>;
};

export function PartnerGeneralFormWidget({
	partnerId,
	data,
	serviceAreas,
}: PartnerGeneralFormWidgetProps) {
	const { t } = useResource();

	return (
		<BaseCard title={t(generalInfoResources.title)}>
			<GeneralInfoForm
				partnerId={partnerId}
				data={data}
				serviceAreas={serviceAreas}
			/>
		</BaseCard>
	);
}
